import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, createVNode as _createVNode, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "mr-2 text-sm py-1 capitalize" }
const _hoisted_2 = {
  key: 0,
  class: "flex flex-wrap"
}
const _hoisted_3 = {
  key: 0,
  class: "flex"
}
const _hoisted_4 = { key: 1 }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("span", { class: "py-1 pl-2.5 pr-2 rounded-full text-sm font-medium text-gray-800 bg-gray-100 mr-1 h-6 justify-center items-center flex my-1" }, " Contacts enrolled in this workflow ", -1)
const _hoisted_6 = [
  _hoisted_5
]

import { computed } from "vue"
import ContactSelect from "@/components/profile-details/middle-panel/ContactSelect.vue"
import { XIcon } from "@heroicons/vue/outline"
import { InboxContact } from "@/shared/models/inbox"
import { getSendTypeForWorkflow, internationalPhoneFormat, getFullNameWithoutUnknown } from "@/shared/utils/helpers"
import { useWorkflowStore } from "@/stores/workflow"
import SendEmailComponent from "@/components/workflows/sidebar/action/communications/SendEmailComponent.vue"

interface Props {
    type: string
    fieldName: string
    recipients: InboxContact[]
    offsetWidth?: number
    isReply?: boolean
    isForward?: boolean
    from?: string
    to?: string[]
    isWorkflow?: boolean
}


export default /*#__PURE__*/_defineComponent({
  __name: 'ContactSelectorField',
  props: {
    type: {},
    fieldName: {},
    recipients: {},
    offsetWidth: {},
    isReply: { type: Boolean },
    isForward: { type: Boolean },
    from: {},
    to: {},
    isWorkflow: { type: Boolean, default: false }
  },
  emits: ["addRecipient", "removeRecipient", "closeContactSelect"],
  setup(__props: any, { emit: __emit }) {

const workflowStore = useWorkflowStore()

const props = __props

const emit = __emit

const localRecipints = computed(() => props.recipients)
const isMessageType = computed(() => props.type === "sms")
const field = computed(() => `${props.fieldName}Field`)

function getRecipientEmailOrPhone(recipient: InboxContact) {
    return isMessageType.value && recipient?.phone?.number
        ? internationalPhoneFormat(recipient?.phone?.number || "")
        : getRecipientEmail(recipient)
}

function getRecipientEmail(recipient: InboxContact) {
    if (!props.isReply || props.isForward) {
        return recipient?.email || ""
    }

    if (recipient.email !== props.from) {
        return props.to?.[0]
    }

    return props.from
}

function addRecipient(recipient: InboxContact) {
    emit("addRecipient", recipient)
}

function removeRecipient(index: number) {
    emit("removeRecipient", index)
}

function closeContactSelect() {
    emit("closeContactSelect")
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    ref: field.value,
    class: "w-full text-sm font-medium flex flex-wrap items-center min-h-[38px]"
  }, [
    _createElementVNode("span", _hoisted_1, _toDisplayString(_ctx.fieldName) + ":", 1),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(localRecipints.value, (recipient, index) => {
      return (_openBlock(), _createElementBlock("span", {
        key: recipient._id,
        class: "py-1 pl-2.5 pr-2 rounded-full text-sm font-medium text-gray-800 bg-gray-100 mr-1 h-6 justify-center items-center flex my-1"
      }, [
        _createTextVNode(_toDisplayString(_unref(getFullNameWithoutUnknown)(recipient.firstName, recipient.lastName, recipient.fullName)) + "  " + _toDisplayString(getRecipientEmailOrPhone(recipient)) + " ", 1),
        _createVNode(_unref(XIcon), {
          class: "text-gray-400 rounded-full m-0 h-4 w-4 inline-block ml-1 cursor-pointer hover:bg-gray-200",
          onClick: ($event: any) => (removeRecipient(index))
        }, null, 8, ["onClick"])
      ]))
    }), 128)),
    (_ctx.isWorkflow)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          (_unref(workflowStore).currentComponent.__name === SendEmailComponent.__name)
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(workflowStore).emailSendingTypes, (sendType) => {
                  return (_openBlock(), _createElementBlock("span", {
                    key: sendType,
                    class: "py-1 pl-2.5 pr-2 rounded-full text-sm font-medium text-gray-800 bg-gray-100 mr-1 h-6 justify-center items-center flex my-1"
                  }, _toDisplayString(_unref(getSendTypeForWorkflow)(sendType)), 1))
                }), 128))
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_4, _hoisted_6))
        ]))
      : (_openBlock(), _createBlock(ContactSelect, {
          key: 1,
          type: _ctx.type,
          recipients: _ctx.recipients,
          toFieldLength: _ctx.offsetWidth,
          fieldName: _ctx.fieldName,
          onClose: closeContactSelect,
          onSelect: addRecipient
        }, null, 8, ["type", "recipients", "toFieldLength", "fieldName"]))
  ], 512))
}
}

})